<template>
  <el-dialog
    :title="$t('SeaExport.ModifyStatus')"
    :visible.sync="dialogShow"
    width="480px"
  >
    <div>
      <div no="1">{{ $t('SeaExport.ModifyManifestStatusTip') }}</div>
    </div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <el-form label-position="right" label-width="90px">
        <el-form-item :label="$t('SeaExport.SoNo')" class="lable-blue">
          <div style="display: flex; align-items: center; gap: 10px;">
            <el-select v-model="selectedSoNos" multiple collapse-tags no="2" style="width: 230px;" @change="handleSoNoChange">
              <el-option
                v-for="item in soNos"
                :key="item.soNo"
                :label="item.soNo"
                :value="item.soNo"
              />
            </el-select>
            <el-checkbox v-model="allSoNos" @change="handleAllSoNosChange">{{ $t('SeaExport.AllSoNos') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ReceiptStatus')" class="lable-blue" style="width: 320px;">
          <el-select v-model="status" no="3">
            <el-option
              v-for="item in allowModifyTypes"
              :key="item.code"
              :label="isZh ? item.chineseName : item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveEventHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="dialogShow = false">{{ $t('SeaExport.Return') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as EdiState from '@/class/cargo/model/parameters/EdiState'
import { updateManifestStatus } from '@/api/seaExport/manifestInfo'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'ModifyManifestStatusDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    manifestInfo: { type: Object, required: true },
    jobUuid: { type: String, required: false }
  },
  data() {
    return {
      dialogShow: false,
      soNos: [],
      selectedSoNos: [], // 绑定到下拉框，存储选中的 soNo
      manifestGoodsUuids: [],
      allSoNos: false,
      status: EdiState.DELETION_SUCCESS.code,
      allowModifyTypes: EdiState.ALLOW_MODIFY_TYPES
    }
  },
  computed: {
    isZh() {
      return this.$i18n.locale === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      this.dialogShow = newVal
      this.manifestGoodsUuids = []
      this.selectedSoNos = []
      this.status = EdiState.DELETION_SUCCESS.code
      this.init()
    },
    dialogShow(newVal) {
      this.$emit('update:visible', newVal)
    },
    selectedSoNos(newVal) {
      this.allSoNos = newVal.length === this.soNos.length
    },
    soNos() {
    },
    manifestInfo(newVal) {
      this.init()
    }
  },
  created() {
    if (this.visible) {
      this.dialogShow = true
    }
    this.init()
  },
  methods: {
    handleSoNoChange(selectedSoNos) {
      // 每次变动时，清空 manifestGoodsUuids，然后重新填充
      this.manifestGoodsUuids = []

      // 遍历选中的 soNo，找到对应的 uuids 并合并到 manifestGoodsUuids 中
      selectedSoNos.forEach(soNo => {
        const item = this.soNos.find(i => i.soNo === soNo)
        if (item) {
          this.manifestGoodsUuids = this.manifestGoodsUuids.concat(item.uuids)
        }
      })
    },
    handleAllSoNosChange(checked) {
      if (checked) {
        // 如果复选框被勾选，选中所有的 soNo
        this.selectedSoNos = this.soNos.map(item => item.soNo)

        // 将所有 uuids 添加到 manifestGoodsUuids
        this.manifestGoodsUuids = this.soNos.reduce((acc, item) => {
          return acc.concat(item.uuids)
        }, [])
      } else {
        // 如果复选框取消勾选，清空 selectedSoNos 和 manifestGoodsUuids
        this.selectedSoNos = []
        this.manifestGoodsUuids = []
      }
    },
    init() {
      if (this.manifestInfo && this.manifestInfo.manifestGoods) {
        const soNoMap = new Map()

        // 用 Map 去重显示的 soNo，但保留所有的 uuid
        this.soNos = this.manifestInfo.manifestGoods
          .filter(item => EdiState.MODIFY_TYPES.some(type => type.code === item.seaHouseState))
          .reduce((acc, item) => {
            if (!soNoMap.has(item.soNo)) {
              soNoMap.set(item.soNo, true)
              acc.push({
                soNo: item.soNo, // 显示的 soNo
                uuids: [item.uuid] // 与 soNo 关联的所有 uuid
              })
            } else {
              // 如果 soNo 已存在，将 uuid 加入到相应的数组中
              acc.find(i => i.soNo === item.soNo).uuids.push(item.uuid)
            }
            return acc
          }, [])
      } else {
        this.soNos = []
      }
    },
    async saveEventHandler() {
      this.loading = getLoading()
      if (this.manifestGoodsUuids.length === 0) {
        this.$message.warning(this.$t('SeaExport.PlsSelectSoNo'))
        this.loading.close()
        return
      }
      // 将 manifestGoodsUuids 展平为一个列表
      const flattenedUuids = this.manifestGoodsUuids.flat()

      const data = {
        manifestInfoUuid: this.manifestInfo.uuid,
        manifestGoodsUuids: flattenedUuids, // 使用展平后的 uuids 列表
        soNos: this.soNos,
        jobUuid: this.jobUuid,
        status: this.status
      }

      await updateManifestStatus(data).then(res => {})
      this.dialogShow = false
      this.$message.success(this.$t('SeaExport.ModificationSuccessful'))
      this.$emit('reload')
      this.loading.close()
    }
  }
}
</script>
<style lang="scss" scoped>

.lable-blue ::v-deep {
  .el-form-item__label {
    color: #1F75D5 !important;
  }
}

</style>
